import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { AdSpaceInterface } from '../../../interfaces/interfaces';

export const getAdSpacesColumns = (
  setAdSpaceToDelete: (adSpace: AdSpaceInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setAdSpaceToUpdate: (adSpace: AdSpaceInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'userId', headerName: 'User ID', width: 100 },
    { field: 'geoName', headerName: 'Geo Name', width: 150 },
    { field: 'description', headerName: 'Description', width: 200 },
    { field: 'adSpaceMediaTypeId', headerName: 'Media Type ID', width: 120 },
    { field: 'sizeWidth', headerName: 'Width', width: 90 },
    { field: 'sizeHeight', headerName: 'Height', width: 90 },
    { field: 'sizeDataTypeId', headerName: 'Size Data Type ID', width: 120 },
    { field: 'country', headerName: 'Country', width: 100 },
    { field: 'province', headerName: 'Province', width: 100 },
    { field: 'city', headerName: 'City', width: 100 },
    { field: 'area', headerName: 'Area', width: 100 },
    { field: 'street', headerName: 'Street', width: 120 },
{
    field: 'longLatCoords',
    headerName: 'Coords',
    width: 200,
    sortable: false,
    filterable: false,
    renderCell: (params: any) => {
        const coords = params.row?.longLatCoords?.coordinates;
        if (Array.isArray(coords) && coords.length === 2) {
            const [lng, lat] = coords;
            const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
            return (
                <a
                    href={mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline', color: '#1976d2' }}
                >
                    {lat}, {lng}
                </a>
            );
        }
        return '';
    },
},
    { field: 'priceWeekly', headerName: 'Price Weekly', width: 110 },
    { field: 'priceMonthly', headerName: 'Price Monthly', width: 110 },
    { field: 'priceYearly', headerName: 'Price Yearly', width: 110 },
    { field: 'availableFrom', headerName: 'Available From', width: 150 },
    { field: 'currencyId', headerName: 'Currency ID', width: 100 },
    { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
    { field: 'created_at', headerName: 'Created', width: 150 },
    { field: 'updated_at', headerName: 'Updated', width: 150 },
    {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
        <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
            setAdSpaceToDelete(params.row);
            setDeleteDialogOpen(true);
        }}
        >
        Delete
        </Button>
    ),
    sortable: false,
    filterable: false,
    },
    {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
        <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
            setAdSpaceToUpdate(params.row);
            setUpdateDialogOpen(true);
        }}
        >
        Update
        </Button>
    ),
    sortable: false,
    filterable: false,
    },
];
